import Accordion from '@accede-web/accordion';

function getHeight( panel ){
  panel.style.display = 'block';
  panel.style.height = 'auto';
  panel.panelHeight = panel.clientHeight;
  panel.removeAttribute( 'style' );
}


function handleClose( header, panel ){
  getHeight( panel );

  panel.style.display = 'block';
  panel.style.height = [ panel.panelHeight/16, 'rem' ].join('');

  window.requestAnimationFrame( function(){
    panel.classList.remove( 'open' );
    panel.style.height = 0;

    window.setTimeout( function(){
      panel.removeAttribute( 'style' );
    }, 400 );
  });
}

function handleOpen( header, panel ){
  getHeight( panel );

  panel.style.display = 'block';
  panel.style.height = 0;

  window.requestAnimationFrame( function(){

    panel.style.height = [ panel.panelHeight/16, 'rem' ].join('');

    panel.classList.add( 'open' );

    window.setTimeout( function(){
      panel.removeAttribute( 'style' );
    }, 400 );
  } );
}

function init(){
  var lists = Array.prototype.slice.call( document.querySelectorAll( '[data-role="accordion"]' ));

  console.log(lists)

  lists.forEach( function( list ) {
    var accordion = new Accordion( list );

    accordion.on( 'show', handleOpen );
    accordion.on( 'hide', handleClose );

    accordion.mount();
  });
}

if( document.body.classList.contains( 'accordeon' )  ){
  init();
}
